import * as tslib_1 from "tslib";
import { createAction, createReducer, createSelector, on, props } from '@ngrx/store';
import * as noteSelectors from '../courses/selectors';
export var saveNotes = createAction('[Notes] Save Note', props());
export var getNotesComplete = createAction('[Notes] Set Note', props());
export var getNotes = createAction('[Notes] Get Note', props());
export var startSaving = createAction('[Notes] Start Saving');
export var doneSaving = createAction('[Notes] Done Saving');
export var initialState = {
    notesMap: {},
    isSaving: false,
    lastSavedDate: new Date(),
};
var ɵ0 = function (state, action) {
    var _a;
    return (tslib_1.__assign({}, state, { notesMap: tslib_1.__assign({}, state.notesMap, (_a = {}, _a[action.lectureId] = action.noteContent, _a)) }));
}, ɵ1 = function (state) { return (tslib_1.__assign({}, state, { isSaving: true })); }, ɵ2 = function (state) { return (tslib_1.__assign({}, state, { isSaving: false, lastSavedDate: new Date() })); };
export var notesReducer = createReducer(initialState, on(getNotesComplete, ɵ0), on(startSaving, ɵ1), on(doneSaving, ɵ2));
export function reducer(state, action) {
    return notesReducer(state, action);
}
var ɵ3 = function (state) { return state.notes; }, ɵ4 = function (state) { return noteSelectors.getCurrentLesson(state.course); }, ɵ5 = function (notes, currentLesson) { return currentLesson && notes.notesMap[currentLesson.system_id]; };
export var selectLectureNotes = createSelector(ɵ3, ɵ4, ɵ5);
var ɵ6 = function (state) { return state.notes; }, ɵ7 = function (notes) { return ({ isSaving: notes.isSaving, savedAt: notes.lastSavedDate }); };
export var selectNotesSaveStatus = createSelector(ɵ6, ɵ7);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
